// Module
var code = "<svg ref=\"chartEl\"></svg> ";
// Exports
export default code;